import script from "./AudienceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceList.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceList.vue?vue&type=style&index=0&id=6aca717a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aca717a"]])

export default __exports__